// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3rLLa","empty":"ModalGraph_empty__2qqO3"};